module.exports = __webpack_public_path__ + "static/vista-explodida-2-928bb4a97010d8041605f11b888ee2a0.png";